import {mapActions, mapGetters, mapState} from 'vuex'
import {checkReturnStatus} from '../../../../../common/utils/return-message-util'
import * as ReturnMessageConstants from '../../../../../constants/ReturnMessageConstants'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'

export default {
  data () {
    return {
      additionalCarVisible: true,
      memberInfoForm: {
        memberName: '',
        phoneNumber: '',
        carNumber: '',
        vinCode: '',
        vehicleName: '',
        captcha: ''
      },
      selectName: '吉',
      content: '获取验证码',
      totalTime: 60,
      canClick: true,
      hiddenState: false,
      memberInfoRules: {
        phoneNumber: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[0-9]{10}$/, message: '请输入11位手机号'}
        ],
        carNumber: [
          {required: true, message: '请输入车牌号', trigger: 'blur'}
        ],
        vinCode: [
          {required: true, message: '请输入底盘号', trigger: 'blur'},
          { min: 17, max: 17, message: '请输入17位底盘号', trigger: 'change' },
          { pattern: /^[0-9A-Z]{17}$/, message: '底盘号只支持数字和字母' }
        ],
        captcha: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      carTypeList: ['A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q2', 'Q3', 'Q5', 'Q7', 'Q8', 'S3', 'TT', 'R8']
    }
  },
  computed: {
    ...mapState('wxMemberModule', ['memberDetail', 'memberCarAttribution']),
    ...mapGetters('wxMemberModule', ['memberAvatarUrl', 'memberVerificationStatus']),
    avatarUrl () {
      return this.memberAvatarUrl
    },
    memberDetailInfo () {
      if (this.memberDetail) {
        this.memberInfoForm.memberName = this.memberDetail.memberName
        this.memberInfoForm.phoneNumber = this.memberDetail.phoneNumber
        return this.memberDetail
      } else {
        return {
          memberName: '',
          phoneNumber: '',
          carNumber: '',
          vinCode: '',
          vehicleName: '',
          captcha: '',
          memberCarDTOList: []
        }
      }
    },
    vinCodeToUpperCase: {
      get: function () {
        return this.memberInfoForm.vinCode
      },
      set: function (val) {
        this.memberInfoForm.vinCode = val.toUpperCase()
      }
    },
    carNumberToUpperCase: {
      get: function () {
        return this.memberInfoForm.carNumber
      },
      set: function (val) {
        this.memberInfoForm.carNumber = val.toUpperCase()
      }
    },
    vehicleNameToUpperCase: {
      get: function () {
        return this.memberInfoForm.vehicleName
      },
      set: function (val) {
        this.memberInfoForm.vehicleName = val.toUpperCase()
      }
    },
    provinceOptions () {
      return this.memberCarAttribution
    }
  },
  methods: {
    ...mapActions('wxMemberModule', ['getMemberDetail', 'commitApplication', 'getCaptchaAuthNew', 'getSelectProvinceInfo',
      'uploadFileGetVinCode', 'deleteCarInfoById']),
    waitApprove () {
      this.$refs['memberForm'].validate(async (valid) => {
        if (valid) {
          this.memberInfoForm.carNumber.toUpperCase()
          this.memberInfoForm.vinCode.toUpperCase()
          this.memberInfoForm.vehicleName.toUpperCase()
          let form = {
            memberName: this.memberInfoForm.memberName,
            phoneNumber: this.memberInfoForm.phoneNumber,
            carNumber: this.selectName + this.memberInfoForm.carNumber,
            vinCode: this.memberInfoForm.vinCode,
            vehicleName: this.memberInfoForm.vehicleName,
            captcha: this.memberInfoForm.captcha
          }
          const result = await this.commitApplication(form)
          if (!checkReturnStatus(result)) return
          if (result.data.code === ReturnMessageConstants.FAIL_CODE ||
            result.data.code === ReturnMessageConstants.FAIL_CODE_NO_CAR ||
            result.data.code === ReturnMessageConstants.FAIL_CODE_REPEAT_PHONE_NUMBER ||
            result.data.code === ReturnMessageConstants.REPEAT_CAR_NUMBER) {
            this.$message.error(`${result.data.info}`)
          } else {
            this.$message.success('添加车辆成功')
            this.memberInfoForm = {
              memberName: '',
              phoneNumber: '',
              carNumber: '',
              vinCode: '',
              vehicleName: '',
              captcha: ''
            }
            this.additionalCarVisible = true
            this.getMemberDetail()
            setTimeout(this.$router.go(-1),3000)

          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getCode () {
      if (!this.memberInfoForm.phoneNumber) {
        this.$message.warning('请输入手机号后再发送验证码')
        return
      }
      let data = {
        phoneNumber: this.memberInfoForm.phoneNumber
      }
      const result = await this.getCaptchaAuthNew(data)
      if (result && result.code === ReturnMessageConstants.REPEAT_VERIFICATION_CODE) {
        this.$message.warning('已发送验证码，请三分钟之后在重新发送')
        return
      }
      this.setTime()
    },
    setTime () {
      if (!this.canClick) return // 如果是false 直接return出去
      this.canClick = false
      this.content = this.totalTime + 's'
      let clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + 's'
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = '获取验证码'
          this.totalTime = 60
          this.canClick = true // 这里重新开启
        }
      }, 1000)
    },
    // additionalCarVisible () {
    //   this.additionalCarVisible = false
    // },
    async getBase64 (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        let fileResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          fileResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(fileResult)
        }
      })
    },
    // 上传之前对文件判断
    async beforeAvatarUpload (data) {
      // 这是限制上传文件类型
      const isLt2M = data.file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      } else {
        let resBase64 = await this.getBase64(data.file)
        let fileBase64 = resBase64.split(',')[1]
        const result = await this.uploadFileGetVinCode(fileBase64)
        this.vinCodeToUpperCase = result.vinCode
        this.selectName = result.carNumber.split('')[0]
        this.carNumberToUpperCase = result.carNumber.substr(1)
        this.memberInfoForm.memberName = result.ownerName
        return file
      }
    },
    // 上传成功或者失败都会触发
    returnStatus () {
      console.log()
    },
    // 限制文件上传个数
    handleExceed (file) {
      console.log(file)
    },
    blurInput () {
      this.hiddenState = false
    },
    async deleteCarInfo (item) {
      const result = await this.deleteCarInfoById(item.id)
      if (result && (result.code === ReturnMessageConstants.FAIL_CODE_NO_CAR ||
        result.code === ReturnMessageConstants.FAIL_CODE)) {
        this.$message.warning('删除失败')
        return
      }
      this.getMemberDetail()
    }
  },
  mounted () {
    // 获取会员个人信息详情
    this.getMemberDetail()
    this.getSelectProvinceInfo(DictionaryConstants.MEMBER_CAR_ATTRIBUTION)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-car/views/add-my-car.js